module.exports = __webpack_public_path__ + "img/Orange_Business_Services-2.0b21389b.png";